import React from 'react';
import NotifyArea2 from '../../../home/Contract/CustomControl/NotifyArea2';
import { Card } from "react-bootstrap";

class NotifyControl2 extends React.Component {
    render() {
        return (
            <Card style={{ marginBottom: 10 }}>
                <Card.Header as="h5">{this.props.actionsObj.title}</Card.Header>
                <Card.Body>
                    <NotifyArea2
                        key={this.props.skey + "CRD"}
                        skey={this.props.skey + "CRD"}
                        expanded={true}
                        actionsObj={this.props.actionsObj}
                        contract={this.props.contract}
                        contractTemplate={this.props.contractTemplate}
                    />
                </Card.Body>
            </Card>
        );
    }
}

export default NotifyControl2;